<template>
	<div class="pageContainer app-container">
		<el-row class="">
			<el-select v-model="searchForm.ktype" size="small" placeholder="请选择"
				style="width: 150px; margin-right: 10px;">
				<el-option label="学生姓名" value="stu_name">学生姓名</el-option>
				<el-option label="学生编号" value="stu_code">学生编号</el-option>
			</el-select>
			<el-input v-model="searchForm.keyword" size="small" placeholder="请输入"
				style="max-width: 200px;margin-right: 10px" />
      <el-select v-model="searchForm.is_report" size="small" placeholder="报到状态"
                 style="width: 150px; margin-right: 10px;" clearable>
        <el-option label="已报到" :value="1">已报到</el-option>
        <el-option label="未报到" :value="0">未报到</el-option>
      </el-select>
<!--      <el-cascader ref="firstCascader" :options="treeData" :props="treeProps" size="small"
                   v-model="searchForm.dept_id" :show-all-levels="false" @change="handleCascaderChange" placeholder="系部专业班级"
                   style="width: 50%; width: 200px; margin-right: 10px" filterable clearable></el-cascader>-->
			<el-button size="small" icon="el-icon-search" @click="onSearch" plain type="primary">查询</el-button>
			<el-button size="small" icon="el-icon-refresh" @click="onReset" type="warning">重置</el-button>

			<!-- <el-popconfirm width="250" confirmButtonText='确定' cancelButtonText='取消' icon="el-icon-info" iconColor="red" @confirm="mutiDel"
			 title="是否确定删除？">
				<el-button slot="reference" size="small" icon="el-icon-delete" type="danger" style="margin-left: 10px;">
					删除
				</el-button>
			</el-popconfirm> -->
		</el-row>
		<el-row type="flex" style="margin: 20px 0;" justify="start">
			<el-tabs v-model="activeName" type="border-card" style="width: 100%">
				<el-tab-pane v-for="item in tabMapOptions" :key="item.key" :label="item.label" :name="item.key">
					<el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" border stripe
						@selection-change="handleSelectionChange">
						<el-table-column type="selection" width="55">
						</el-table-column>
						<el-table-column prop="index" width="55" label="序号">
							<template slot-scope="scope">
								{{ scope.$index + 1 + ((page.pageIndex - 1) * page.pageSize) }}
							</template>
						</el-table-column>
						<el-table-column prop="stu_name" label="姓名"></el-table-column>
						<el-table-column prop="exam_num" label="考试证号"></el-table-column>
            <el-table-column prop="exam_score" label="总分" width="80" sortable="custom"></el-table-column>
            <el-table-column prop="exam_score" label="类型" width="60" v-if="$store.state.pmid==4">
              <template slot-scope="scope">
                <span v-if="scope.row.ctype==1">统招</span>
                <span v-if="scope.row.ctype==0">补录</span>
              </template>
            </el-table-column>
            <el-table-column prop="volunteer" label="志愿" width="80">
              <template slot-scope="scope">
                <span v-if="scope.row.volunteer==1">第一志愿</span>
                <span v-if="scope.row.volunteer==2">第二志愿</span>
                <span v-if="scope.row.volunteer==3">第三志愿</span>
                <span v-if="scope.row.volunteer==0">无志愿</span>
              </template>
            </el-table-column>
            <el-table-column prop="gender" label="性别" width="60">
              <template slot-scope="scope">
                <span v-if="scope.row.gender==1">男</span>
                <span v-if="scope.row.gender==2">女</span>
                <span v-if="scope.row.gender==0">未知</span>
              </template>
            </el-table-column>
            <el-table-column prop="graduate_sch_city" label="地区" width="150"></el-table-column>
            <el-table-column prop="yx_name" label="系部" width="120"></el-table-column>
            <el-table-column prop="major_name" label="专业代号及名称" min-width="120"></el-table-column>
            <el-table-column prop="class_name" label="班级" min-width="100"></el-table-column>
            <el-table-column prop="phone" label="联系方式" min-width="120"></el-table-column>
            <el-table-column prop="is_report" label="报到状态" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.is_report==1" style="color:darkgreen">已报到</span>
                <span v-if="scope.row.is_report==0">未报到</span>
              </template>
            </el-table-column>
						<el-table-column fixed="right" label="操作" width="160">
							<template slot-scope="scope">
								<el-button v-if="!scope.row.is_report" @click="handleModify(scope.row)" type="text"
									size="small">修改</el-button>
                <el-button v-else @click="handleView(scope.row)" type="text"
                           size="small">查看</el-button>
							</template>
						</el-table-column>
					</el-table>
					<el-pagination @current-change="handlePageChange" :current-page="page.pageIndex"
						:page-size="page.pageSize" layout="total, prev, pager, next, jumper" :total="page.total">
					</el-pagination>

				</el-tab-pane>
			</el-tabs>
		</el-row>

    <el-dialog :title="modalTitle" width="850px" :visible.sync="isShowModal" :close-on-click-modal="false"
               @close="isShowModal = false">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>基本信息</span>

        </div>

        <el-form :model="formData" inline :rules="rules" ref="adminUserInfo" label-width="100px">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="学生姓名" prop="stu_name">
                <el-input size="small" readonly v-model.trim="formData.stu_name" style="width: 100%"
                          placeholder="学生姓名" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="身份证号" prop="identity_card">
                <el-input size="small" readonly type="text" v-model.trim="formData.identity_card"
                          @change="getBirthdayFromIdCard" placeholder="身份证号" style="width: 100%" />
              </el-form-item>
            </el-col>

          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="建档号" prop="archive">
                <el-input readonly type="text" size="small" v-model.trim="formData.archive" style="width: 100%"
                          placeholder="建档号" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="考试证号" prop="exam_num">
                <el-input readonly  size="small" type="text" v-model.trim="formData.exam_num" style="width: 100%"
                          placeholder="考试证号" />
              </el-form-item>
            </el-col>
          </el-row>




          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="性别" prop="gender">
                <el-radio-group readonly size="small" v-model="formData.gender">
                  <el-radio disabled :label="1">男</el-radio>
                  <el-radio disabled :label="2">女</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="出生日期" prop="birthday">
                <el-date-picker readonly size="small" v-model="formData.birthday"
                                value-format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width:200px">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否住校" prop="birthday">

                <el-radio-group  v-model="formData.dorm">
                  <el-radio disabled :label="1">是</el-radio>
                  <el-radio disabled :label="0">否</el-radio>
                </el-radio-group>

              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="中考成绩" prop="birthday">
                <el-input readonly size="small" v-model.trim="formData.exam_score" style="width: 100%"
                          placeholder="中考成绩" />
              </el-form-item>
            </el-col>


            <el-col :span="12">
              <el-form-item label="民族" prop="民族">
								<span slot="label">民族</span>
                <el-select disabled size="small" v-model="formData.minzu" style="width: 200px;">
                  <el-option v-for="(item,index) in minzuList" :key="index" :value="item"
                             :label="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="户口所在" prop="phone">
                <el-cascader disabled ref="hukou" :options="hukouData" size="small"
                             style="width: 200px;" :props="firstCascaderPropsArea" v-model="formData.hukou_code"
                             @change="handleCascaderChange" placeholder="请选择" clearable></el-cascader>

              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="详细地址" prop="phone">
                <el-input readonly size="small" v-model.trim="formData.jtzz" style="width: 570px"
                          placeholder="详细地址" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系方式" prop="phone">
                <el-input readonly size="small" v-model.trim="formData.phone" style="width: 100%"
                          placeholder="手机号码" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="录取性质">
                <el-input readonly size="small" readonly="" v-model.trim="formData.xuezhi"
                          style="width: 100%" placeholder="从专业中选择" />
              </el-form-item>
            </el-col>
          </el-row>


          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="专业" prop="major_id">
                <el-input readonly placeholder="请选择专业" v-model="formData.major_name" size="small"></el-input>

              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="班级" prop="class_id">
                <el-input readonly size="small" v-model.trim="formData.class_name" style="width: 100%"
                          placeholder="班级" />
              </el-form-item>
            </el-col>
          </el-row>


          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="毕业地区" prop="graduate_sch_city" style="width: 100%; display: block;">
                <el-cascader disabled ref="firstCascader" :options="areas" size="small"
                             style="width: 200px;" :props="firstCascaderPropsArea"
                             v-model="formData.graduate_dist_code" @change="handleCascaderChangeArea"
                             placeholder="请选择" clearable></el-cascader>
              </el-form-item>
            </el-col>



            <el-col :span="12">
              <el-form-item label="毕业学校" prop="graduate_schname" style="width: 100%; display: block;">
                <div class="flexStart" style="width: 100%;">
                  <el-input readonly size="small" v-model.trim="formData.graduate_schname"
                            @input="$forceUpdate()" style="width: 200px;margin-left: 0px;"
                            placeholder="若学校不在选择之列，请自行填写" />

                </div>

              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="监护人姓名" prop="phone">
                <el-input readonly size="small" v-model.trim="formData.jhr1name" style="width: 100%"
                          placeholder="监护人姓名" />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="监护人电话" prop="phone">
                <el-input readonly size="small" v-model.trim="formData.jhr1phone" style="width: 100%"
                          placeholder="监护人电话" />
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="formData.is_report && formData.report_date">
              <el-form-item label="报到时间" prop="phone">
                <el-input readonly size="small" v-model.trim="formData.report_date" style="width: 100%"
                          placeholder="报到时间" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24" v-if="!formData.is_report">
              <el-divider></el-divider>
              <el-form-item label="未报到原因" prop="no_report_reason">
                <el-input  v-model.trim="formData.no_report_reason" type="textarea"
                           placeholder="请输入未报到原因"
                           maxlength="500"
                           show-word-limit
                           :autosize="{ minRows: 2, maxRows: 6 }" style="width: 450px" />
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>

      </el-card>

      <el-card class="box-card" v-if="formData.is_report">
        <div slot="header" class="clearfix">
          <span>其他信息</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="8">
            <span>身高（CM）:</span>
            <el-input size="small" readonly=""  v-model.trim="formData.pjson.height" style="width: 120px; margin-left: 10px;"
                      placeholder="身高" />

          </el-col>
          <el-col :span="8">

            <span>体重（KG）:</span>
            <el-input size="small" readonly=""  v-model.trim="formData.pjson.weight" style="width: 120px; margin-left: 10px;"
                      placeholder="体重" />

          </el-col>
          <el-col :span="8">

            <span>鞋码:</span>
            <el-input size="small" readonly=""  v-model.trim="formData.pjson.shoes" style="width: 120px; margin-left: 10px;"
                      placeholder="体重" />

          </el-col>
        </el-row>
      </el-card>
      <el-row class="flexEnd">
        <el-button size="small" type="warning" @click="isShowModal = false">关闭</el-button>
        <el-button v-if="!formData.is_report" size="small" type="primary" @click="submitForm('adminUserInfo')">提交</el-button>
      </el-row>
    </el-dialog>
	</div>
</template>
<script>
import api from '@/api/api';
import area from "../../utils/arae_value"

export default {
	name: 'report',
	data() {
		var checkPhone = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('手机号不能为空'));
			} else {
				const reg = /^1[2|3|4|5|6|7|8|9][0-9]\d{8}$/

				if (reg.test(value)) {
					callback();
				} else {
					return callback(new Error('请输入正确的手机号'));
				}
			}
		};
		return {
			searchForm: {
				ktype: 'stu_name',
			}, //查询
			//dialog
			visible: false,
			isShowModal: false,
			isShowRole: false,
			updDialog: false,
			modalTitle: '添加',
			formData: {},
			firstCascaderProps: {
				label: 'dept_name',
				value: 'id',
				children: 'children',
				emitPath: false,
				multiple: true,
				checkStrictly: true
			},

			rules: {
        no_report_reason: [{
					required: true,
					message: '请输入未报到原因',
					trigger: 'blur'
				},],
			},
			//tree
			treeData: [],
      treeProps: {
        children: "children",
        label: "title",
        value: "id",
        checkStrictly: true,
        emitPath: false,
      },

			//table
			tabMapOptions: [{
				label: '报到列表',
				key: 'CN'
			},],
			activeName: 'CN',
			tableData: [],
			page: {
				pageIndex: 1,
				pageSize: 20,
				total: 0
			},
			multipleSelection: [],
			deptId: null,
			tchId: null,
			authData: [],
      hukouData: [],
      areas: [],
      minzuList: "汉族、蒙古族、回族、藏族、维吾尔族、苗族、彝族、壮族、布依族、朝鲜族、满族、侗族、瑶族、白族、土家族、哈尼族、哈萨克族、傣族、黎族、僳僳族、佤族、畲族、高山族、拉祜族、水族、东乡族、纳西族、景颇族、柯尔克孜族、土族、达斡尔族、仫佬族、羌族、布朗族、撒拉族、毛南族、仡佬族、锡伯族、阿昌族、普米族、塔吉克族、怒族、乌孜别克族、俄罗斯族、鄂温克族、德昂族、保安族、裕固族、京族、塔塔尔族、独龙族、鄂伦春族、赫哲族、门巴族、珞巴族、基诺族",
      firstCascaderPropsArea: {
        children: 'children',
        label: 'label',
        value: 'value',
        emitPath: false,
      },
		}
	},
	watch: {
		activeName(val) {
			this.$router.push(`${this.$route.path}?tab=${val}`)
		}
	},
	created() {
		// init the default selected tab
		const tab = this.$route.query.tab
		if (tab) {
			this.activeName = tab
		}
	},
	mounted() {
    this.minzuList = this.minzuList.split("、")
    let hkdata = JSON.parse(JSON.stringify(area))
    for (let p of hkdata) {
      for (let c of p.children) {
        delete c.children
      }
    }
    this.hukouData = hkdata
    this.areas = area
		this.getList();
		this.getOrgList();
	},
	methods: {
		//tree
		getOrgList() {
			let _this = this
			this.$http.post('/api/sch_major_list_and_num').then(res => {
				if (res.data && res.data.length > 0) {
					_this.deleteEmptyGroup(res.data).then(result => {
						_this.treeData = result
					})
				}
			})
		},
		// 处理没有children的分组
		deleteEmptyGroup(treeData) {
			return new Promise(resolve => {
				function traversal(data) {
					data.map(item => {
						for (let info in item) {
							if (item['children']) {
								if (item['children'].length > 0) {
									traversal(item['children'])
								}
								if (item['children'].length == 0) {
									delete item['children']
								}
							}
						}
					})
				}

				traversal(treeData)
				resolve(treeData)
			})
		},

		//table
		getList() {
			let params = {
				page: this.page.pageIndex,
				pagesize: this.page.pageSize,
				ktype: this.searchForm.ktype,
				keyword: this.searchForm.keyword,
        is_report: this.searchForm.is_report,
			}
			this.$http.post('/api/sch_stu_report_list', params).then(res => {
				this.tableData = res.data.data;
				this.page.total = res.data.page.count;
			})
		},
		handleModify(row) {
			this.isShowModal = true;
			this.modalTitle = '修改';
			this.formData = row
		},
    handleView(row) {
      this.isShowModal = true;
      this.modalTitle = '查看';
      if (typeof row.pjson !== "object") {
        row.pjson = JSON.parse(row.pjson)
      }
      this.formData = row
    },
		handlePageChange(e) {
			this.page.pageIndex = e
			this.getList()
		},
		handleCascaderChange(e) {
			console.log(1, e)
		},
		submitForm(formName) {
			let _this = this
			_this.$refs[formName].validate((valid) => {
				if (valid) {
					let params = {
            remark: _this.formData.no_report_reason,
            stu_id: _this.formData.id,
					}
					_this.$http.post('/api/stu_no_report_save', params).then(res => {
						if (res.data.code == 500) {
							this.$message.warning(res.data.msg ? res.data.msg : '保存失败')
						} else {
							this.$message.success('保存成功')
							this.getList();
							this.isShowModal = false;
						}
					})
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		onSearch() {
			this.tableData = [];
			this.page.pageIndex = 1;
			this.getList();
		},
		onReset() {
			this.searchForm = {
				ktype: 'username'
			};
			this.tableData = [];
			this.page.pageIndex = 1;
			this.getList();
		},
		handleSelectionChange(val) {
			let _this = this;
			_this.multipleSelection = val;
		},
    getBirthdayFromIdCard: function(idCard) {
      let _this = this
      let birthday = "";
      if (idCard != null && idCard != "") {
        if (idCard.length == 15) {
          birthday = "19" + idCard.substr(6, 6);
          birthday = `${birthday.substr(0, 4)}-${birthday.substr(4, 2)}-${birthday.substr(6, 2)}`
          this.formData.birthday = birthday
        } else if (idCard.length == 18) {
          birthday = idCard.substr(6, 8);
          birthday = `${birthday.substr(0, 4)}-${birthday.substr(4, 2)}-${birthday.substr(6, 2)}`
          this.formData.birthday = birthday
        }
        this.formData = {
          ..._this.formData
        }
      }

    },
    handleCascaderChangeArea(e) {
      let node = this.$refs['firstCascader'].getCheckedNodes()[0].pathLabels
      this.formData.graduate_sch_city = node.join(',')
      this.getSchoolList(e)
      console.log(e)
      this.getAreaScore(e)

    },
	}
}
</script>

<style scoped lang="less" type="text/less">
.app-container {
	.treeContainer {
		height: 100%;
		background-color: #fff;
		box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .12), 0 0 6px 0 rgba(0, 0, 0, .04);
		border: 1px solid rgba(220, 223, 230, 0.6);

		.treeTitle {
			height: 40px;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			color: #409eff;
			padding-left: 6px;
		}
	}

	.roleitem {
		display: inline-block;
		padding: 1px 5px;
		font-size: 12px;
		background-color: #00B0E8;
		color: #fff;
		margin-right: 5px;
		margin-bottom: 5px;
		border-radius: 2px;
	}
}
</style>
